export const tableHeaderCustomStyle = {
  bold: true,
  fontSize: 10,
  color: 'white',
  border: [false, false, false, false],
  textTransform: 'uppercase',
};
